module.exports = __webpack_public_path__ + "img/IMG_0448.77d70829.jpg";